const options = {
  5: "bg-black/5",
  10: "bg-black/10",
  25: "bg-black/25",
  50: "bg-black/50",
  75: "bg-black/75",
  90: "bg-black/90",
  100: "bg-black",
};

const from = {
  5: "from-black/5",
  10: "from-black/10",
  25: "from-black/25",
  50: "from-black/50",
  75: "from-black/75",
  90: "from-black/90",
  100: "from-black",
};

export default function getBackgroundBlack(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
